<template>
  <!-- <div class="permissions-btn"> -->
  <el-button
    v-if="roleList[path].includes(permissionName)"
    :icon="icon"
    :size="size"
    :type="btnType"
    @click="handleDownload"
    >导出</el-button
  >
  <!-- </div> -->
</template>
<script>
import { mapGetters } from 'vuex';
import { download } from '@/utils/download';
import { getToken } from '@/utils/token.js';
export default {
  name: 'PermissionsBtn',
  props: {
    icon: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    btnType: {
      type: String,
      default: '',
    },
    permissionName: {
      type: String,
      default: '',
    },
    downloadUrl: {
      type: String,
      default: '',
    },
    checkList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      path: '',
    };
  },
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  methods: {
    // 操作按钮
    handleDownload() {
      if (this.permissionName === '_Export') {
        this.onExport();
      } else {
        // 其他逻辑
      }
    },
    // 导出
    async onExport() {
      // console.log('导出筛选条件', this.form);
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      try {
        let baseUrl = window.RequestUrl;
        let token = getToken();
        let newToken = JSON.parse(token);
        // 客户管理
        // /userAdmin/Introduce/downLoad
        // 直播预告管理
        // /live/LiveAdvanceNotice/downLoad
        // 主播管理
        // /live/Anchor/downLoad
        const houseId = [
          '/userAdmin/Introduce/downLoad',
          '/live/LiveAdvanceNotice/downLoad',
          '/live/Anchor/downLoad',
        ].includes(this.downloadUrl)
          ? JSON.parse(getToken('userInfo')).houseId
          : '';
        await this.$axios({
          url: baseUrl + this.downloadUrl,
          method: 'POST',
          responseType: 'arraybuffer',
          data: {
            idList: this.checkList,
            ...this.form,
            areaId,
          },
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
            authorization: 'Bearer ' + newToken.accessToken,
            houseId,
          },
        }).then((res) => {
          // 调用封装好的下载函数
          download(
            res.data,
            'application/excel;charset=UTF-8',
            this.$moment().format('YYYY-MM-DD-HH-mm') + '.xlsx'
          );
        });
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
